
export function capitalizeEveryWord(str: string, exclusion: string = ''): string {
    // console.log(str)
    return str.split(' ').filter(s => s).map(word => {
        word = (word == exclusion ? word.toUpperCase() : word.toLowerCase())
        return (word !== exclusion ? word[0].toUpperCase() + word.substring(1) : word)
    }).join(' ')
}
